var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg7(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.60135 28.0011C5.5838 28.0011 4.75891 28.826 4.75891 29.8436V30.125H23.8114V28.0011H6.60135ZM24.749 31.0625V32H2.88391V29.8436C2.88391 27.7905 4.54827 26.1261 6.60135 26.1261H25.6864V31.0625H24.749Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6865 5.97693V28.0011H9.88197V11.3471L25.6865 5.97693ZM11.757 12.6903V26.1261H23.8115V8.59432L11.757 12.6903Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.45235 12.5125L28.5129 5.01653L29.1161 6.79184L7.05558 14.2878L6.45235 12.5125Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.88 9.935V3.80338H18.755V9.935H16.88Z",
    fill: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.88 23.4646V18.9992H18.755V23.4646H16.88Z",
    fill: "#222222"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.95 3.87587H15.2183V2.00087H20.95V3.87587Z",
    fill: "#222222"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9525 1.875C11.3661 1.875 10.8906 2.35045 10.8906 2.93694C10.8906 3.52342 11.3661 3.99887 11.9525 3.99887H13.3522C13.9386 3.99887 14.4141 3.52342 14.4141 2.93694C14.4141 2.35045 13.9386 1.875 13.3522 1.875H11.9525ZM9.0156 2.93694C9.0156 1.31492 10.3305 0 11.9525 0H13.3522C14.9742 0 16.2891 1.31492 16.2891 2.93694C16.2891 4.55895 14.9742 5.87387 13.3522 5.87387H11.9525C10.3305 5.87387 9.0156 4.55895 9.0156 2.93694Z",
    fill: "#222222"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.2290d7395a386cfece17631016c6cc2f.svg";
export { ForwardRef as ReactComponent };